var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Devices/Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16602 4.16667C3.945 4.16667 3.73304 4.25446 3.57676 4.41074C3.42552 4.56198 3.33842 4.76537 3.33296 4.97864C3.52462 8.01525 4.81734 10.8781 6.9693 13.0301C9.12125 15.182 11.9841 16.4747 15.0207 16.6664C15.234 16.6609 15.4374 16.5738 15.5886 16.4226C15.7449 16.2663 15.8327 16.0543 15.8327 15.8333V13.0642L12.8488 11.8706L11.9639 13.3454C11.7408 13.7173 11.2697 13.8559 10.8808 13.6641C8.90663 12.6905 7.3089 11.0927 6.3353 9.1186C6.14347 8.72963 6.28205 8.25856 6.65394 8.03542L8.12871 7.15056L6.93515 4.16667H4.16602ZM2.39825 3.23223C2.86709 2.76339 3.50297 2.5 4.16602 2.5H7.49935C7.8401 2.5 8.14653 2.70746 8.27308 3.02384L9.93975 7.19051C10.0917 7.57027 9.94549 8.00414 9.59476 8.21458L8.19976 9.05158C8.88631 10.1713 9.82809 11.113 10.9478 11.7996L11.7848 10.4046C11.9952 10.0539 12.4291 9.9077 12.8088 10.0596L16.9755 11.7263C17.2919 11.8528 17.4993 12.1592 17.4993 12.5V15.8333C17.4993 16.4964 17.236 17.1323 16.7671 17.6011C16.2983 18.0699 15.6624 18.3333 14.9993 18.3333C14.9825 18.3333 14.9656 18.3328 14.9488 18.3318C11.495 18.1219 8.23748 16.6553 5.79078 14.2086C3.34409 11.7619 1.87744 8.50433 1.66755 5.05055C1.66653 5.03372 1.66602 5.01686 1.66602 5C1.66602 4.33696 1.92941 3.70107 2.39825 3.23223Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.29e5adc95b02cb21270bdb2956929b05.svg";
export { ForwardRef as ReactComponent };